const translations = {
  "en": {
    "Create new portfolio": "Create new portfolio",
    "Manage my portfolio": "Manage my portfolio"
  },
  "zh-tw": {
    "Create new portfolio": "建立新投資組合",
    "Manage my portfolio": "管理我的投資組合"
  }
};

export default translations;
